import {createTheme} from '@material-ui/core';
import {OptumTheme} from '@pcs/specialty-ui';
import type {ThemeOptions, Theme} from '@material-ui/core';

const getMaterialUiTheme = (themeOptions?: ThemeOptions): Theme => {
  const overrides: ThemeOptions = {
    overrides: {
      MuiButton: {
        root: {
          '&:focus, &:focus-within': {
            outline: `2px solid #316BBE`,
          },
        },
        containedSecondary: {
          backgroundColor: '#ffffff',
        },
      },
      MuiIconButton: {
        root: {
          '&:focus, &:focus-within': {
            outline: `2px solid #316BBE`,
          },
        },
      },
      MuiLink: {
        root: {
          display: 'inline-block',
          '&:focus, &:focus-within, &:focus-visible': {
            outline: `2px auto #316BBE`,
            outlineOffset: '3px',
          },
        },
      },
    },
    ...(themeOptions ? {...themeOptions} : {}),
  };

  return createTheme(OptumTheme, overrides);
};

export default getMaterialUiTheme;
